import { render, staticRenderFns } from "./AddTagDialog.vue?vue&type=template&id=481062e9&"
import script from "./AddTagDialog.vue?vue&type=script&lang=js&"
export * from "./AddTagDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports